<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-02-08 09:38:40
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-20 10:42:21
-->
<template>
  <div class="contain">
    <section>
      <div class="manageContent">
        <div class="count">
          <div
            class="count-item"
            :style="{
              'background-image': `url(${require('@/assets/images/patentImg' +
                (index + 1) +
                '.png')})`
            }"
            v-for="(item, index) in list"
            :key="index"
          >
            <div>{{ item.name }}</div>
            <div class="num">{{ item.num }}</div>
          </div>
        </div>
      </div>
    </section>
    <div>
      <div class="header">发明专利</div>
      <div v-if="inventPatentList && inventPatentList.length">
        <el-image
          v-for="(item, index) in inventPatentList"
          :key="index"
          class="imgStyle"
          :src="item.ossUrl"
          :preview-src-list="[item.ossUrl]"
        ></el-image>
      </div>
      <div v-else class="empty-msg">
        <img src="@/assets/images/暂无数据.png" alt="" />
        <div>暂无数据</div>
      </div>
      <div class="header">实用新型专利</div>
      <div v-if="utilityModelList && utilityModelList.length">
        <el-image
          v-for="(item, index) in utilityModelList"
          :key="index"
          class="imgStyle"
          :src="item.ossUrl"
          :preview-src-list="[item.ossUrl]"
        ></el-image>
      </div>
      <div v-else class="empty-msg">
        <img src="@/assets/images/暂无数据.png" alt="" />
        <div>暂无数据</div>
      </div>
      <div class="header">外观设计专利</div>
      <div v-if="designPatentList && designPatentList.length">
        <el-image
          v-for="(item, index) in designPatentList"
          :key="index"
          class="imgStyle"
          :src="item.ossUrl"
          :preview-src-list="[item.ossUrl]"
        ></el-image>
      </div>
      <div v-else class="empty-msg">
        <img src="@/assets/images/暂无数据.png" alt="" />
        <div>暂无数据</div>
      </div>
      <div class="header">国外专利</div>
      <div v-if="foreignPatentsList && foreignPatentsList.length">
        <el-image
          v-for="(item, index) in foreignPatentsList"
          :key="index"
          class="imgStyle"
          :src="item.ossUrl"
          :preview-src-list="[item.ossUrl]"
        ></el-image>
      </div>
      <div v-else class="empty-msg">
        <img src="@/assets/images/暂无数据.png" alt="" />
        <div>暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPatentData } from '@api/corporateInteraction/enterprise'
export default {
  props: {
    creditCode: {
      type: String,
      default: ''
    }
  },
  computed: {},
  components: {},
  data() {
    return {
      ruleForm: {},
      list: [
        { name: '专利数量', num: '', numObj: 'patentNumber' },
        { name: '发明专利数量', num: '', numObj: 'inventPatentNumber' },
        { name: '实用新型专利数量', num: '', numObj: 'utilityModelNumber' },
        { name: '外观设计专利数量', num: '', numObj: 'designPatentNumber' },
        { name: '国外专利数量', num: '', numObj: 'foreignPatentsNumber' }
      ],
      inventPatentList: [], // 发明专利图片
      foreignPatentsList: [], // 国外专利
      designPatentList: [], // 外观设计专利
      utilityModelList: [] // 实用新型专利图片
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getSearch()
  },
  methods: {
    getSearch() {
      getPatentData({ creditCode: this.creditCode }).then(res => {
        if (res.data.code === '0000') {
          this.list.map(item => {
            item.num = res.data.data[item.numObj]
              ? res.data.data[item.numObj]
              : '-'
          })
          this.inventPatentList = res.data.data.inventPatentes
          this.foreignPatentsList = res.data.data.foreignPatentes
          this.designPatentList = res.data.data.designPatentes
          this.utilityModelList = res.data.data.utilityModeles
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  .header {
    color: rgba(255, 255, 255, 100);
    font-size: 0.16rem;
    margin-bottom: 0.16rem;
    line-height: 0.36rem;
    font-weight: 600;
    &::before {
      content: '';
      vertical-align: middle;
      margin-top: -0.03rem;
      width: 0.03rem;
      height: 0.18rem;
      display: inline-block;
      margin-right: 0.1rem;
      background: #00fffe;
    }
  }
  .imgStyle {
    width: 3.36rem;
    height: 1.86rem;
    margin-right: 0.2rem;
  }
  section {
    margin-top: 0.2rem;
    .manageContent {
      font-size: 0.16rem;
      .count {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.2rem;
        &-item {
          background: url('~@/assets/images/patentImg1.png') no-repeat center
            center;
          background-size: 100% 100%;
          width: 19%;
          height: 0.96rem;
          padding: 0.16rem 0.24rem;
          .num {
            color: rgba(0, 255, 254, 100);
            font-size: 0.32rem;
            line-height: 0.36rem;
            margin-top: 0.06rem;
          }
        }
      }
    }
  }
  .empty-msg {
    line-height: 0.22rem;
    // height: 0.22rem;
    margin: 0.08rem 0.2rem 0;
    color: rgba(0, 255, 254, 100);
    font-size: 0.14rem;
    text-align: left;
    font-family: PingFangSC-Regular;
    img {
      width: 0.72rem;
      height: 0.77rem;
    }
  }
}
</style>
